import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import KeysByWeekByCompanyList from './components/week/KeysByWeekByCompanyList';
import KeysByMonthByCompanyList from './components/month/KeysByMonthByCompanyList';

function KeysByCompany() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Keys by company"
      MonthList={KeysByMonthByCompanyList}
      WeekList={KeysByWeekByCompanyList}
      storageKey="report-group-by"
    />
  );
}

export default KeysByCompany;
